<script>
import { useLeadMetaStore } from '@/stores/useLeadMetaStore';
import { permissionsMixin } from '@/mixins/userPermissions';

export default {
  inject: ['setLoading', 'auth'],
  mixins: [permissionsMixin],
  data() {
    return {
      errors: {},
      title: 'Settings',
      text: 'Administration',
      text1: 'Settings',
      searchText: '',
      rowSelection: null,
    };
  },
  computed: {
    canSeeLocation() {
      return this.getPermission('HRMS_Setup', 'read');
    },
    columns() {
      const cols = [
        { title: 'S.No', dataIndex: 'SNo', key: 'SNo' },
        { title: 'Branch Name', dataIndex: 'BranchName', key: 'BranchName' },
        { title: 'Branch Code', dataIndex: 'BranchCode', key: 'BranchCode' },
      ];
      if (this.canSeeLocation) {
        cols.push({ title: 'Location', key: 'Location' });
      }
      cols.push({ title: 'Actions', key: 'action' });
      return cols;
    },
    branchList() {
      return useLeadMetaStore().branches || [];
    },
    filteredData() {
      if (!this.searchText) return this.branchList;
      const search = this.searchText.toLowerCase();
      return this.branchList.filter((item) => item.name?.toLowerCase().includes(search));
    },
  },
  async mounted() {
    this.setPermissions(this.auth);
    const store = useLeadMetaStore();
    if (!store.branches.length) {
      this.setLoading(true);
      try {
        await store.refreshBranches();
      } finally {
        this.setLoading(false);
      }
    }
  },
  methods: {
    hasLocation(row) {
      return row.latitude != null && row.longitude != null;
    },
    async onBranchUpdated() {
      await useLeadMetaStore().refreshBranches();
    },
  },
};
</script>

<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div class="head-icons ms-2"></div>
      </div>
      <!-- /Breadcrumb -->

      <settings-tab></settings-tab>
      <div class="row">
        <general-sidebar></general-sidebar>
        <div class="col-xl-9">
          <div class="card">
            <div class="card-body">
              <div class="border-bottom d-flex align-items-center justify-content-between pb-3 mb-3">
                <h4>Branches Details</h4>
                <div>
                  <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#branch_modal"
                    class="btn btn-primary d-flex align-items-center" @click="$refs.branchModal.branch();">
                    <i class="ti ti-circle-plus me-2"></i>Add Branch
                  </a>
                </div>
              </div>
              <div class="card-body p-0">
                <div class="card mb-0">
                  <div class="card-header d-flex align-items-center justify-content-between">
                    <a-input v-model:value="searchText" placeholder="Search branch name..." allow-clear style="width: 300px;" />
                  </div>
                  <div class="custom-datatable-filter table-responsive">

                    <a-table v-if="filteredData.length" class="table datatable thead-light" :columns="columns"
                      :data-source="filteredData" :row-selection="rowSelection">
                      <template #bodyCell="{ column, record, index }">
                        <template v-if="column.key === 'SNo'"> {{ index + 1 }}. </template>
                        <template v-if="column.key === 'BranchName'">
                          <h6 class="fs-14 fw-medium">
                            <router-link to="#">{{ record.name }}</router-link>
                          </h6>
                        </template>
                        <template v-if="column.key === 'BranchCode'">{{ record.code }}</template>

                        <!-- Location (HRMS permission only) -->
                        <template v-if="column.key === 'Location'">
                          <span v-if="hasLocation(record)" class="br-loc-set">
                            <i class="ti ti-map-pin-check me-1"></i>Set
                            <span class="br-loc-radius" v-if="record.radius_meters">({{ record.radius_meters }}m)</span>
                          </span>
                          <span v-else class="br-loc-none">
                            <i class="ti ti-map-pin-off me-1"></i>Not set
                          </span>
                        </template>

                        <template v-if="column.key === 'action'">
                          <div class="action-icon d-inline-flex">
                            <a href="javascript:void(0);" class="me-2" data-bs-toggle="modal" data-bs-target="#branch_modal"
                              @click="$refs.branchModal.branch(record)">
                              <i class="ti ti-edit"></i>
                            </a>
                            <a href="javascript:void(0);" class="text-danger" data-bs-toggle="modal" data-bs-target="#delete_modal"
                              @click="$refs.branchModal.branch(record)">
                              <i class="ti ti-trash"></i>
                            </a>
                          </div>
                        </template>
                      </template>
                    </a-table>

                    <div v-else class="p-3 text-center text-muted">
                      No records found.
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Page Wrapper -->

  <app-footer></app-footer>

  <branch-modal ref="branchModal" @updated="onBranchUpdated"></branch-modal>
</template>

<style scoped>
.br-loc-set {
  font-size: 11.5px;
  font-weight: 600;
  color: #16a34a;
}
.br-loc-radius {
  font-size: 10.5px;
  color: #94a3b8;
  font-weight: 400;
}
.br-loc-none {
  font-size: 11.5px;
  color: #cbd5e1;
}
</style>